import React from 'react';

import AppStoreIcon from './icon/AppStoreIcon';
import GooglePlayIcon from './icon/GooglePlayIcon';
import { ButtonLinkExternal } from './lib/Button';

const MobileStoreOptions = (props: { size?: 'lg' | 'sm'; block?: boolean }) => (
  <div>
    <div>
      <ButtonLinkExternal
        sm={props.size === 'sm'}
        block={props.block}
        href="https://apps.apple.com/app/apple-store/id1500521120"
      >
        <AppStoreIcon size={props.size === 'sm' ? '1rem' : '1.15rem'} />
        <span className="tw-ml-1">Apple App Store</span>
      </ButtonLinkExternal>
    </div>
    <div className="tw-mt-6">
      <ButtonLinkExternal
        sm={props.size === 'sm'}
        block={props.block}
        href="https://play.google.com/store/apps/details?id=com.intertimesmobile"
      >
        <GooglePlayIcon size={props.size === 'sm' ? '1rem' : '1.15rem'} />
        <span className="tw-ml-1">Google Play Store</span>
      </ButtonLinkExternal>
    </div>
    <div className="tw-mt-6">
      <img
        src="/static/mind/img/app-store-qr.svg"
        width={200}
        height={200}
        className="tw-bg-gray-300 dark:tw-bg-gray-600"
      />
    </div>
  </div>
);

export default MobileStoreOptions;
